import React from 'react';
import { Link } from "gatsby";
import { Location } from './locationTypes';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import LaunchIcon from '@material-ui/icons/Launch';
import MapIcon from '@material-ui/icons/Map';
import MoreIcon from '@material-ui/icons/More';
import SharpImage from "../utils/sharpImage"
import { LocationCardStyles } from "./LocationCard.styles";
import StyledLinkSecondary from '../common/styledLinkSecondary';

interface Props {
    location: Location;
    onShowOnMap?: (location: Location) => void;
};

export const LocationCard = ({ location, onShowOnMap }: Props) => {
    const classes = LocationCardStyles();
    const toPath = "/";// locationUrl(location);
    const hasShowOnMapLink = onShowOnMap && typeof (onShowOnMap) === "function";

    const showOnMap = () => {
        if (!hasShowOnMapLink) return;
        onShowOnMap(location);
    }

    return (
        <Card className={classes.locationCard} raised={false} elevation={0}>
            <CardMedia
                className={classes.locationCardCover}>
                {location.logo && location.logo.childImageSharp && location.logo.childImageSharp.gatsbyImageData ?
                    <>
                        <div style={{ width: "250px", height: "250px", margin: "auto" }}><SharpImage file={location.logo} title={location.name} altText={location.name} style={{ margin: "auto", marginTop: 5 }} imgStyle={{ width: "250px", height: "250px" }} /></div>
                    </>
                    : null}

            </CardMedia>

            <div className={classes.locationCardDetails}>
                <CardContent className={classes.locationCardContent}>
                    <Typography color="textSecondary" align="center">
                        {location.name}
                    </Typography>
                    <Typography variant="subtitle1" color="textSecondary" align="center">
                        <address>{location.address} {location.city} {location.state} {location.postcode}</address>
                    </Typography>
                    <StyledLinkSecondary href={location.url}><Typography align="center">{location.url}</Typography></StyledLinkSecondary>
                </CardContent>


                {/*<div className={classes.locationCardControls}>

                    {toPath && (
                        <IconButton aria-label="More" className={classes.locationCardControlButton}>
                            <Link to={toPath}>
                                <MoreIcon />
                            </Link>
                        </IconButton>
                    )}
                    {hasShowOnMapLink && (
                        <IconButton aria-label="Show on Map" onClick={showOnMap} className={classes.locationCardControlButton}>
                            <MapIcon />
                        </IconButton>
                    )}
                    {location.url && (
                        <IconButton aria-label="Open" className={classes.locationCardControlButton}>
                            <a href={location.url} target="_blank" rel="noopener">
                                <LaunchIcon />
                            </a>
                        </IconButton>
                    )}
                </div>*/}

            </div>

        </Card>
    );
}

export default LocationCard;